"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lab_1 = require("@material-ui/lab");
const core_1 = require("@material-ui/core");
require("./adminPagination.scss");
const AdminPagination = ({ data }) => {
    return (react_1.default.createElement(core_1.Box, { className: 'admin-pagination' },
        react_1.default.createElement(lab_1.Pagination, { onChange: (e, page) => data.pageChange(e, page), page: data.currentPage, count: data.count, color: "primary" }),
        react_1.default.createElement("span", null,
            data.from,
            " - ",
            data.to,
            " of ",
            data.total)));
};
exports.default = AdminPagination;
